import { addressBookStyles } from "@insite/content-library/Widgets/Addresses/AddressBook";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

addressBookStyles.addressHeaderGridItem = {
    width: 12,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        > div[class^="Wrapper"] {
                            > div[class^="GridWrapper"] {
                                > div[class^="GridOffset"] {
                                    > div[class^="GridItemStyle-sc"] {
                                        &:first-child {
                                            flex-basis: 85%;
                                            max-width: 85%;
                                        }
                                        &:nth-child(2) {
                                            flex-basis: 15%;
                                            max-width: 15%;
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    null,
                    null,
                ],
                "max",
            )}
    `,
};
addressBookStyles.addressCard = {
    gridContainer: { gap: 20 },
    addressInfoDisplayGridItem: { width: [10, 10, 5, 7, 7] },
    actionsGridItem: {
        width: [2, 2, 7, 5, 5],
        css: css`
            justify-content: flex-end;
        `,
    },
    actionUseAsShippingAddressButton: {
       variant:"secondary",
      
    },
    actionEditLink: {
        css: css`
            display: block;
            margin: 20px auto 0 auto;
        `,
    },
    bottomBorderGridItem: { width: 12 },
    bottomBorder: {
        css: css`
            height: 1px;
            background-color: ${getColor("common.border")};
            width: 100%;
        `,
    },
    overflowMenu: {
        cssOverrides: {
            menu: css`
                width: 210px;
            `,
            wrapper: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            button {
                                background: none !important;
                            }
                        `,
                        css`
                            button {
                                background: none !important;
                            }
                        `,
                        css`
                            button {
                                background: none !important;
                            }
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
};
